module.exports = __webpack_public_path__ + "static/media/cloud-background.11452cab.png";